module.exports = __webpack_public_path__ + "img/album17_19.25845f46.jpg";